export default {
    HOME: 'HOME',
    LOGIN: 'LOGIN',
    RESET_PASSWORD: 'RESET_PASSWORD',
    LOGOUT: 'LOGOUT',
    CL_PROFILE: 'CL_PROFILE',
    ENROLMENTS: 'ENROLMENTS',
};
